export default __webpack_public_path__ + "static/media/Jacket_16_9.2ec57700.png";